import { IkeFieldType } from '@ikegps/core-api';
import type { FormModelField } from '../../form/form.field';
import type { FormModelFieldSelectList } from '../../form/form.select.list';
import { CollectionModelField, ModelMutator } from '../collection.field';
import { registerFieldType } from './field.registry';

export class ModelMutatorSelectList extends ModelMutator<FormModelField, CollectionModelFieldSelectList> {
	manual(newText: string | null) {
		const option = this.field.schema.findOption(newText);
		if (option == null) {
			this.state.setFieldValue<string>(this.field.id, null);
			return;
		}
		this.state.setFieldValue<string>(this.field.id, option.value);
	}

	override copy(from: CollectionModelFieldSelectList): boolean {
		if (!from.hasValue()) {
			this.manual(null);
			return true;
		}

		const value = from.value;
		if (this.field.schema.findOption(value) != null) {
			this.manual(value);
			return true;
		}

		return false;
	}
}
export class CollectionModelFieldSelectList extends CollectionModelField<FormModelFieldSelectList, string> {
	static TYPE: IkeFieldType = IkeFieldType.SELECT_LIST;

	static isSelectListField(f: CollectionModelField): f is CollectionModelFieldSelectList {
		return f.schema.type === CollectionModelFieldSelectList.TYPE;
	}

	private _Mutator: ModelMutatorSelectList;
	get Mutator() {
		if (this._Mutator == null) {
			this._Mutator = new ModelMutatorSelectList(this);
		}
		return this._Mutator;
	}

	override get value(): string {
		return this.stateValue || this.schema.unselectedValue;
	}

	override get displayValue(): string {
		const opt = this.schema.findOption(this.value);
		if (opt != null) {
			return opt.text;
		}
		return null;
	}

	get color(): string | null {
		const opt = this.schema.findOption(this.value);
		if (opt?.color) {
			return opt.color;
		}
		return null;
	}

	hasValue(): boolean {
		return this.value !== this.schema.unselectedValue;
	}
}

registerFieldType(
	IkeFieldType.SELECT_LIST,
	(parent, schema) => new CollectionModelFieldSelectList(parent, <FormModelFieldSelectList>schema)
);
